<template>
  <el-button v-bind="$attrs" @click="$emit('click', $event)">
    <template v-if="icon" #icon>
      <el-icon><component :is="icon" /></el-icon>
    </template>
    <slot />
  </el-button>
</template>

<script>
export default {
  name: "UiButton",
  props: {
    icon: [Object, Function],
  },
}
</script>

<style scoped>
:deep(.el-icon){ margin-right:8px; }
</style>
